import React, { useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/index'
import Creation from './components/creationArea/Creation'
import Error from './components/Error'
import CreationShape from './components/creationArea/CreationShape'
import InvaderPage from './components/InvaderPage'
import './App.module.css'

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Creation />,
      errorElement: <Error />,
      children: [
        { path: '/', element: <CreationShape /> },
        { path: ':id', element: <InvaderPage /> },
      ],
    },
  ])

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  )
}

export default App
